import { LanguageType } from './types';

/**
 * Get language from cookies (for server components)
 * @param cookieStore - Next.js cookies() return value
 */
export function getLanguageFromCookies(cookieStore: any): LanguageType {
  const preferredLanguage = cookieStore.get('preferredLanguage')?.value;
  return preferredLanguage === 'arabic' ? 'arabic' : 'english';
}

/**
 * Resolve language for a server page, with `?lang=` URL param taking priority
 * over the cookie when present. Use this in `page.tsx` files so first-time
 * visitors landing on `?lang=ar` links see Arabic content immediately (Strapi
 * fetched in Arabic, layout direction correct, etc.).
 *
 * @param cookieStore - Next.js cookies() return value
 * @param searchParams - awaited result of the page's searchParams prop
 */
export function getLanguage(
  cookieStore: any,
  searchParams: { lang?: string | string[] } | undefined,
): LanguageType {
  const raw = searchParams?.lang;
  const langParam = Array.isArray(raw) ? raw[0] : raw;
  if (langParam === 'ar') return 'arabic';
  if (langParam === 'en') return 'english';
  return getLanguageFromCookies(cookieStore);
}

/**
 * Get language from browser cookies (for client components)
 * Reads directly from document.cookie
 */
export function getLanguageFromBrowserCookies(): LanguageType {
  if (typeof document === 'undefined') {
    return 'english';
  }
  
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'preferredLanguage') {
      return value === 'arabic' ? 'arabic' : 'english';
    }
  }
  
  return 'english';
}

